import React, { useState } from "react";
import Modal from "react-modal";
import SearchNButtons from "../../common-components/SearchNButtons";
import DPForm from "./DPForm";

const DPfilters = ({
  token,
  filters,
  setFilters,
  searchFilterApplied,
  onClickSearch,
  handleKeyPress,
  callFunction,
}) => {
  const [modals, setModal] = useState(false);

  return (
    <>
      <Modal
        isOpen={modals}
        onRequestClose={() => {
          setModal(false);
        }}
        contentLabel="Diet Package Form Modal"
        ariaHideApp={false}
      >
        <DPForm
          token={token}
          closeModal={() => setModal(false)}
          callFunction={callFunction}
        />
      </Modal>

      <SearchNButtons
        pageName={"dp"}
        btnText={"+ Add"}
        filters={filters}
        setFilters={setFilters}
        searchFilterApplied={searchFilterApplied}
        onClickSearch={onClickSearch}
        onClickAdd={() => setModal(true)}
        handleKeyPress={handleKeyPress}
      />
    </>
  );
};

export default DPfilters;
